import { useEffect } from 'react';
import goToCinder from 'utils/goToCinder';

export const NavigateToCinder = ({ path }: { path: string }) => {
  useEffect(() => {
    goToCinder(path);
  }, []);
  return null;
};
